import { createContext } from "react";

export type QuestionnaireResponseExportTask = {
  questionnaireId: string;
  questionnaireTitle: string;
  questionnaireSchemaId: string;
  schemaLabel: string;
  createdAtFrom: string;
  createdAtTo: string;
  responseCount: number;
  startedAt: Date;
};

export type QuestionnaireResponseExportState =
  | {
      status: "idle";
      currentTask: null;
      error: null;
    }
  | {
      status: "running";
      currentTask: QuestionnaireResponseExportTask;
      error: null;
    }
  | {
      status: "success";
      currentTask: QuestionnaireResponseExportTask;
      error: null;
    }
  | {
      status: "error";
      currentTask: QuestionnaireResponseExportTask | null;
      error: string;
    };

export type QuestionnaireResponseExportContextValue = {
  state: QuestionnaireResponseExportState;
  startExport: (
    task: Omit<QuestionnaireResponseExportTask, "startedAt">,
  ) => Promise<void>;
  clearError: () => void;
};

export const QuestionnaireResponseExportContext = createContext<
  QuestionnaireResponseExportContextValue | undefined
>(undefined);
